import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetWorkflowActionsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetWorkflowActionsQueryResult = { __typename?: 'Query' } & {
  workflowActions: Array<{ __typename?: 'WorkflowAction' } & Pick<GraphQLTypes.WorkflowAction, 'label' | 'path' | 'type'>>;
};

export const GetWorkflowActionsDocument = gql`
  query getWorkflowActions {
    workflowActions {
      label
      path
      type
    }
  }
`;
